import React from 'react'
import { LuMapPin } from 'react-icons/lu'
import { Box, Flex, RatingGroup, Text } from '@chakra-ui/react'

import { Testimonial } from '.'

type Props = {
  testimonials: Testimonial[]
  animationType: string
}

const TestimonialCard = ({ testimonials, animationType }: Props) => {
  return (
    <Box position="relative">
      <Box mt="12px" overflow="hidden" position="relative">
        <Flex
          as="ul"
          gap={5}
          animation={`${animationType} 30s linear infinite`}
          w="max-content"
          _hover={{
            animationPlayState: 'paused',
            cursor: 'pointer',
          }}
        >
          {testimonials.map((testimonial, index) => (
            <Flex
              as="li"
              key={`${testimonial.quote}-${index}`}
              direction="column"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="2xl"
              p={5}
              maxW={{ base: '250px', md: '256px', lg: '256px' }}
              // height="160px"
              minW={{ base: '250px', md: '256px', lg: '256px' }}
              flexShrink={0}
            >
              <Flex direction="row" gap={5} alignItems="flex-start" justifyContent="space-between">
                <Flex direction="row" gap={2} alignItems="flex-start">
                  <Box
                    width="31px"
                    height="34px"
                    overflow="hidden"
                    borderRadius="extraSmall"
                    marginTop="4px"
                    marginRight="8px"
                    backgroundImage={`url(/icons/avatars/${(index % 4) + 1}.svg)`}
                  ></Box>
                  <Flex direction="column">
                    <Text fontWeight="bold">{testimonial.author}</Text>
                    <RatingGroup.Root count={5} value={5} size="xs" colorPalette="orange" readOnly>
                      <RatingGroup.HiddenInput />
                      <RatingGroup.Control />
                    </RatingGroup.Root>
                  </Flex>
                </Flex>

                <Flex direction="row" alignItems="flex-start" justifyContent="center" gap={2}>
                  <Text fontSize="11px" textAlign="right" wordBreak="break-all" color="gray.a500" lineClamp="2">
                    {testimonial.address}
                  </Text>
                  <Box width="12px" marginTop="3px">
                    <LuMapPin size="12px" />
                  </Box>
                </Flex>
              </Flex>

              <Box marginTop={4} overflow="hidden">
                <Text whiteSpace="pre-wrap" wordBreak="break-all" fontSize="sm">
                  {testimonial.quote}
                </Text>
              </Box>
            </Flex>
          ))}
        </Flex>
      </Box>
      <Box
        pointerEvents="none"
        position="absolute"
        insetY={0}
        left={0}
        w="20%"
        bgGradient="linear-gradient(to right, #FFFFFF 0, transparent 100%)"
      />
      <Box
        pointerEvents="none"
        position="absolute"
        insetY={0}
        right={0}
        w="20%"
        bgGradient="linear-gradient(to left, #FFFFFF 0%, transparent 100%)"
      />
    </Box>
  )
}

export default TestimonialCard
